<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addEmployee"
                  id="addEmployee"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="requisition_id.value.value"
                        :items="getRfqablePurRequisitionMergeList"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        @update:modelValue="onRequisitionChange"
                        :error-messages="requisition_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Req. Merge
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Rfq Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="rfq_date.value.value"
                        :error-messages="rfq_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Require Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="require_date.value.value"
                        :error-messages="require_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Warehouse
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>


                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="purpose_id.value.value"
                        :items="getPurposeList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="purpose_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Purpose/Project
                          <span class="text-red-accent-4"></span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="department_id.value.value"
                        :items="getHrmDepartmentList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="department_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Department
                          <span class="text-red-accent-4"></span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_ids.value.value"
                        :items="getSupplierMapList"
                        :item-title="(item) => `${item.supplier.supplier_name}`"
                        item-value="id"
                        :error-messages="supplier_ids.errorMessage.value"
                        autocomplete="off"
                        multiple
                        chips
                        clearable
                        :list-props="{ density: 'compact' }"
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        >
                        <template #label>
                          Suppliers
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        label="Rfq By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="rfq_by.value.value"
                        :error-messages="rfq_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Rfq By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="rfq_by_mobile.value.value"
                        :error-messages="rfq_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Rfq By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="rfq_by_email.value.value"
                        :error-messages="rfq_by_email.errorMessage.value"
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Item Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form ref="addEmployee" id="addEmployee">
                  <v-row class="pt-2 justify-center d-none">
                    <v-col cols="8">
                      <v-autocomplete
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        autocomplete="off"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                      <input
                        v-model="rfq_master_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                    <!-- <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col> -->
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 5%">SL</th>
                            <th class="text-left" style="width: 20%">
                              Product Code
                            </th>
                            <th class="text-left" style="width: 25%">
                              Product Name
                            </th>
                            <th class="text-center" style="width: 15%">
                              Quantity
                            </th>
                            <th class="text-center" style="width: 15%">Unit</th>
                            <th class="text-right" style="width: 15%">Rate</th>
                            <th class="text-right" style="width: 15%">
                              Sub Total
                            </th>
                            <th class="text-center" style="width: 10%">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td class="text-left py-1" style="white-space: normal" >
                              {{ item.product_code }}
                            </td>
                            <td class="text-left py-1" style="white-space: normal" >
                              {{ item.product_name }}
                            </td>
                            <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                type="number"
                                style="width: 80px;"
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                :error-messages="
                                  item.qty < 1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.rate
                                "
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>
                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>
                            <td class="text-right py-1">
                              {{ this.$numberFormat(item.rate) }}
                            </td>
                            <td class="text-right py-1">
                              {{ this.$numberFormat(item.total) }}
                            </td>
                            <td class="text-center py-1">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="6" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="6" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Letter Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form ref="addEmployee" id="addEmployee">
                  <!-- Cart Table -->
                  <v-row class="pt-2">
                    <v-col cols="12">
                      <v-col>
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Subject</v-label
                        >
                        <v-text-field
                          label="Subject"
                          class="visually-hidden-label"
                          density="compact"
                          single-line
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="subject.value.value"
                          :error-messages="subject.errorMessage.value"
                          autocomplete="off"
                          clearable
                        ></v-text-field>
                      </v-col>

                      <v-col>
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Letter Terms & Conditions</v-label
                        >
                        <Ckeditor
                          :editor="ClassicEditor"
                          v-model="terms.value.value"
                          :config="editorConfig"
                        />
                      </v-col>

                      <v-col>
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Letter Regards</v-label
                        >
                        <Ckeditor
                          :editor="ClassicEditor"
                          v-model="regards.value.value"
                          :config="editorConfig"
                        />
                      </v-col>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8">
                        <v-label class="text-subtitle-1 font-weight-bold mb-1"
                          >Description</v-label
                        >
                        <v-textarea
                          label="Description"
                          class="visually-hidden-label"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                            class="bg-grey-darken-1 me-2"
                            variant="flat"
                            @click="submitForm(0)"
                            >DRAFT</v-btn
                          >
                          <v-btn
                            class="bg-primary"
                            variant="flat"
                            @click="submitForm(1)"
                            >POST</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { Ckeditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
export default {
  components: {
    Ckeditor,
  },
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
    label: {},
  }),
  watch: {
    getPurLetterInfo: {
      handler() {
        this.setLetterData();
      },
      immediate: true,
    },
  },
  created() {
    // if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    // }
    // if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    // }
    // if (this.$store.getters.getPurposeList.length === 0) {
      this.$store.dispatch("getPurposeList");
    // }
    // if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    // }
    // if (this.$store.getters.getSupplierMapList.length === 0) {
      this.$store.dispatch("getSupplierMapList");
    // }
    
    // if (this.$store.getters.getPurLetterInfo.length === 0) {
      this.$store.dispatch("getPurLetterInfo");
    // }
    
    this.$store.dispatch("getRfqablePurRequisitionMergeList");
  },
  computed: {
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getPurposeList() {
      return this.$store.getters.getPurposeList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
    getSupplierMapList() {
      let suppliers = this.$store.getters.getSupplierMapList;
      return suppliers.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
    getRfqablePurRequisitionMergeList() {
      const requisitions = this.$store.getters.getRfqablePurRequisitionMergeList || [];
      return requisitions;
      // return requisitions.filter(
      //   (item) => item.branch_id == this.branchId && item.status == 1
      // );
    },
    getPurLetterInfo() {
      const letterInfo = this.$store.getters.getPurLetterInfo;
      return letterInfo?.data?.[0] || {};
    },
  },
  methods: {
    setLetterData() {
      const data = this.getPurLetterInfo;
      if (data) {
        this.subject.value.value = data.subject || "";
        this.terms.value.value = data.terms || "";
        this.regards.value.value = data.regards || "";
      }
    },
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_code: product.code,
        product_name: product.name,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        rate: product.purchase_rate,
        total: product.purchase_rate,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
    async onRequisitionChange(selectedId) {
      if (!selectedId) {
        this.cart = [];
        return;
      }

      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        const data = await this.$store.dispatch(
          "getPurRequisitionMergeById",
          selectedId
        );
        this.remarks.value.value = data.remarks || "";

        this.cart = [];
        (data.pur_req_merge_details || []).forEach((item) => {
          this.cart.push({
            product_id: item.product_id,
            product_code: item.product?.code || "",
            product_name: item.product?.name || "",
            qty: item.quantity,
            unit_id: item.product?.unit_id || "",
            unit_name: item.product?.unit?.name || "",
            rate: item.rate,
            total: item.quantity * item.rate,
          });
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.error("Failed to load requisition data:", error);
      }
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        rfq_date: yup.date().required().label("Rfq Date"),
        require_date: yup.date().nullable().label("Require Date"),
        // department_id: yup
        //   .number()
        //   .positive()
        //   .integer()
        //   .required()
        //   .label("Department Name"),
        warehouse_id: yup
          .number()
          .positive()
          .integer()
          .required()
          .label("Designation Name"),
        requisition_id: yup
          .number()
          .positive()
          .integer()
          .required()
          .label("Requisition"),
        supplier_ids: yup
          .array()
          .of(yup.number().positive().integer())
          .min(1, "At least one supplier is required")
          .required()
          .label("Suppliers"),
      }),
    });

    const require_date = useField("require_date");
    const product_id = useField("product_id");
    const pr_status = useField("pr_status");
    const employee_id = useField("employee_id");
    const department_id = useField("department_id");
    const warehouse_id = useField("warehouse_id");
    const purpose_id = useField("purpose_id");
    const requisition_id = useField("requisition_id");
    const supplier_ids = useField("supplier_ids");
    const rfq_master_id = useField("rfq_master_id");
    const rfq_date = useField("rfq_date");
    const subject = useField("subject");
    const terms = useField("terms");
    const regards = useField("regards");
    const remarks = useField("remarks");
    const rfq_by = useField("rfq_by");
    const rfq_by_mobile = useField("rfq_by_mobile");
    const rfq_by_email = useField("rfq_by_email");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.rfq_date = formattedDate(rfq_date.value.value);
      values.require_date = formattedDate(require_date.value.value);
      store
        .dispatch("saveUpdateRfq", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "rfq-record" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    function simpleBase64Plugin(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => ({
        upload: () =>
          loader.file.then(
            (file) =>
              new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve({ default: reader.result });
                reader.readAsDataURL(file);
              })
          ),
        abort: () => {},
      });
    }

    return {
      submitForm,
      submit,
      product_id,
      rfq_date,
      require_date,
      remarks,
      cart,
      rfq_by,
      rfq_by_mobile,
      rfq_by_email,
      subject,
      terms,
      regards,
      pr_status,
      errorMessages,
      employee_id,
      department_id,
      warehouse_id,
      purpose_id,
      requisition_id,
      supplier_ids,
      rfq_master_id,
      buttonText,
      loading,
      ClassicEditor,
      editorConfig: {
        extraPlugins: [simpleBase64Plugin], // Add this line
        toolbar: {
          items: [
            "heading",
            "|",
            "fontFamily",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "subscript",
            "superscript",
            "highlight",
            "|",
            "link",
            "imageUpload",
            "mediaEmbed",
            "|",
            "bulletedList",
            "numberedList",
            "todoList",
            "|",
            "alignment",
            "outdent",
            "indent",
            "|",
            "blockQuote",
            "code",
            "codeBlock",
            "|",
            "insertTable",
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "|",
            "horizontalLine",
            "specialCharacters",
            "removeFormat",
            "findAndReplace",
            "|",
            "undo",
            "redo",
          ],
        },
        height: "500px",
        language: "en",
      },
    };
  },

  mounted() {
    // Load letter data first if not already loaded
    if (!this.$store.getters.getPurLetterInfo) {
      this.$store.dispatch("getPurLetterInfo").then(() => {
        this.setLetterData();
      });
    } else {
      this.setLetterData();
    }

    this.pr_status.value.value = "1";
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.rfq_by.value.value = user.full_name;
    this.rfq_by_mobile.value.value = user.mobile;
    this.rfq_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getRfqById", id)
          .then((data) => {
            this.isEntryMode = false;
            let rfq = data;
            this.rfq_master_id.value.value = rfq.id;
            this.rfq_date.value.value = rfq.rfq_date ? new Date(rfq.rfq_date) : new Date();
            this.require_date.value.value = rfq.require_date ? new Date(rfq.require_date) : new Date();
            this.subject.value.value = rfq.subject;
            this.terms.value.value = rfq.terms;
            this.regards.value.value = rfq.regards;
            this.warehouse_id.value.value = rfq?.warehouse?.id;
            this.purpose_id.value.value = rfq?.purpose_id;
            this.requisition_id.value.value = rfq?.requisition?.id;
            this.department_id.value.value = rfq?.department?.id;
            this.product_id.value.value = null;
            let supplier_ids = [];
            rfq.suppliers.forEach((item) => {
              supplier_ids.push(item.id);
            });
            this.supplier_ids.value.value = supplier_ids;
            this.cart.value = [];

            // Insert items one by one
            (rfq.rfq_details || []).forEach((item) => {
              this.cart.push({
                product_id: item.product_id,
                product_code: item.product?.code || "",
                product_name: item.product?.name || "",
                qty: item.qty,
                unit_id: item.product.unit?.id || "",
                unit_name: item.product.unit?.name || "",
                rate: item.rate,
                total: item.qty * item.rate,
              });
            });
            this.remarks.value.value = rfq.remarks ? rfq.remarks : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch rfq:", error);
          });
      });
    } else {
      this.rfq_master_id.value.value = "";
      this.rfq_date.value.value = new Date();
      this.require_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
<style>
.visually-hidden-label .v-field-label {
  display: none !important;
  display: none !important;
}

.ck-editor__editable {
  min-height: 150px !important;
  height: 150px !important;
}
</style>
